import { Breakpoint } from '@mui/material'
import Stack from '@mui/material/Stack'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import MoovyButton from '../moovyButton'
import DateTimeRangePickerSearchField from './dateTimeRangePickerSearchField'
import SelectSearchField from './selectSearchField'
import TextSearchField from './textSearchField'

export type StateControl<T> = [T, React.Dispatch<React.SetStateAction<T>>]
export type DateTimeRangeStringValues = {
  start: string | null
  end: string | null
}

const SearchBar = (props: {
  id?: string
  onSearch: () => void
  children: React.ReactNode
  breakpoint?: Breakpoint
}) => {
  const onSearch = (event: React.FormEvent) => {
    event.preventDefault()
    props.onSearch()
  }
  const breakpoint = props.breakpoint ?? 'xs'

  return (
    <form
      onSubmit={onSearch}
      id={props.id ?? 'searchBarForm'}
      style={{ width: '100%' }}
    >
      <Stack
        direction={{ xs: 'column', [breakpoint]: 'row' }}
        spacing={1}
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        {props.children}
        <MoovyButton
          type="submit"
          sx={{ width: { xs: '100%', [breakpoint]: 'auto' } }}
        >
          <FormattedMessage id="common.actions.search" />
        </MoovyButton>
      </Stack>
    </form>
  )
}

export default {
  SearchBar,
  TextSearchField,
  DateTimeRangePickerSearchField,
  SelectSearchField,
}
